import actions from './actions'
import mutations from './mutations'
import state from './state'

export const applicationMarital = {
  actions,
  mutations,
  namespaced: true,
  state
}
